export default {
    BEE_OPERATOR          : 'beeOperator',
    EMPLOYEE              : 'employee',
    EXPORTER              : 'exporter',
    BUYER                 : 'buyer',
    MILLER                : 'miller',
    CROP_TRADER           : 'crop_trader',
    CROP_TRADING          : 'crop_trading',
    SUPPLIER_AGRI_INPUT   : 'supplier_agri-input',
    SUPPLIER_RICE         : 'supplier_rice',
    SUPPLIER_CONSUMPTION  : 'supplier_consumption',
    BEE_DEPO              : 'beeDepo',
    BEE_SHOP              : 'beeShop',
    BEE_XPRESS            : 'beeXPress',
    BEE_AGENT             : 'beeAgent',
    FARMER                : 'farmer',
}